// src/pages/FacturacionPresupuestos/tamanoTextoUtils.js

/**
 * Catálogo y especificaciones de secciones del documento comercial
 * con escalado proporcional automático (Separación fija de +4 puntos en títulos).
 */
export const SECCIONES_DOCUMENTO = [
    { id: 'global', nombre: '📄 Toda la Hoja (Global)', defaultSize: 11, min: 8, max: 24 },
    { id: 'emisor', nombre: '🏢 1. Encabezado y Empresa Emisora', defaultSize: 11, min: 8, max: 24 },
    { id: 'cliente', nombre: '👤 2. Datos del Cliente / Receptor', defaultSize: 11, min: 8, max: 24 },
    { id: 'condiciones', nombre: '📋 3. Condiciones del Servicio', defaultSize: 10, min: 8, max: 24 },
    { id: 'partidas', nombre: '📦 4. Desglose de Partidas (Armónico)', defaultSize: 11, min: 8, max: 24 },
    { id: 'totales', nombre: '💰 5. Resumen Financiero y Letras', defaultSize: 11, min: 8, max: 24 },
    { id: 'banco', nombre: '🏦 6. Cuentas Bancarias', defaultSize: 10, min: 8, max: 22 },
    { id: 'notaClave', nombre: '💬 7. Nota Clave / Observaciones', defaultSize: 11, min: 8, max: 24 },
    { id: 'firmas', nombre: '✍️ 8. Firmas de Autorización', defaultSize: 10, min: 8, max: 24 }
];

export const TAMANOS_DEFECTO = {
    global: 11,
    emisor: 11,
    cliente: 11,
    condiciones: 10,
    partidas: 11,
    totales: 11,
    banco: 10,
    notaClave: 11,
    firmas: 10
};

// Separación proporcional establecida por diseño: El título va 4 puntos arriba del contenido
export const DELTA_TITULO_PUNTOS = 4;

/**
 * Obtiene el tamaño base (contenido) configurado para una sección
 */
export const obtenerTamanoSeccion = (documento, seccionId) => {
    if (!documento) return TAMANOS_DEFECTO[seccionId] || 11;
    const config = documento.tamanoTextoSecciones || documento.tamanoContenidoSecciones || {};
    
    if (config[seccionId] !== undefined && config[seccionId] !== null) {
        return Number(config[seccionId]) || TAMANOS_DEFECTO[seccionId] || 11;
    }
    
    if (config.global !== undefined && config.global !== null) {
        return Number(config.global) || TAMANOS_DEFECTO[seccionId] || 11;
    }

    return TAMANOS_DEFECTO[seccionId] || 11;
};

export const obtenerTamanoContenidoSeccion = obtenerTamanoSeccion;

/**
 * Obtiene el tamaño de título de la sección, proporcional con 4 puntos de diferencia
 */
export const obtenerTamanoTituloSeccion = (documento, seccionId) => {
    const base = obtenerTamanoSeccion(documento, seccionId);
    return base + DELTA_TITULO_PUNTOS;
};

/**
 * Aplica un nuevo tamaño de fuente para una sección
 * Ajusta el contenido y mantiene el título proporcional a +4 puntos
 */
export const aplicarTamanoSeccion = (setDocumento, seccionId, nuevoTamano) => {
    const val = Math.max(7, Math.min(26, Number(nuevoTamano) || 11));
    
    setDocumento(prev => {
        const actual = prev.tamanoTextoSecciones || {};
        
        if (seccionId === 'global') {
            const nuevoGlobal = {
                ...actual,
                global: val,
                emisor: val,
                cliente: val,
                condiciones: Math.max(7, val - 1),
                partidas: val,
                totales: val,
                banco: Math.max(7, val - 1),
                notaClave: val,
                firmas: Math.max(7, val - 1)
            };
            return {
                ...prev,
                tamanoTextoSecciones: nuevoGlobal,
                tamanoContenidoSecciones: nuevoGlobal
            };
        }

        const actualizado = {
            ...actual,
            [seccionId]: val
        };

        return {
            ...prev,
            tamanoTextoSecciones: actualizado,
            tamanoContenidoSecciones: actualizado
        };
    });
};

export const aplicarTamanoContenidoSeccion = aplicarTamanoSeccion;

export const aplicarTamanoTituloSeccion = (setDocumento, seccionId, nuevoTamanoTitulo) => {
    // Si se ajusta el título, se deriva el base restando 4 puntos
    const base = (Number(nuevoTamanoTitulo) || 15) - DELTA_TITULO_PUNTOS;
    aplicarTamanoSeccion(setDocumento, seccionId, base);
};

/**
 * Incrementa o decrementa el tamaño de la sección en 1 punto
 */
export const cambiarTamanoDelta = (setDocumento, seccionId, actualTamano, delta) => {
    const nuevo = (Number(actualTamano) || 11) + delta;
    aplicarTamanoSeccion(setDocumento, seccionId, nuevo);
};

export const cambiarTamanoContenidoDelta = cambiarTamanoDelta;
export const cambiarTamanoTituloDelta = cambiarTamanoDelta;

/**
 * Restablece los tamaños de fuente a los valores predeterminados
 */
export const restablecerTamanoSeccion = (setDocumento, seccionId) => {
    setDocumento(prev => {
        const actual = { ...(prev.tamanoTextoSecciones || {}) };
        if (seccionId === 'global') {
            return {
                ...prev,
                tamanoTextoSecciones: { ...TAMANOS_DEFECTO },
                tamanoContenidoSecciones: { ...TAMANOS_DEFECTO }
            };
        }
        delete actual[seccionId];
        return {
            ...prev,
            tamanoTextoSecciones: actual,
            tamanoContenidoSecciones: actual
        };
    });
};
